export const PRICING_BREADCRUMBS_CHEVRON_SIZE = 14;

export const PRICING_FILTER_PANEL_WIDTH = 420;

export const PRICING_CONTENT_MIN_WIDTH = 480;

// The pricing_impact microproduct the hub's recent-changes feed links out to.
// Org-keyed end-to-end, and only present for orgs with it deployed in Salsa.
export const PRICING_IMPACT_MICRO_PRODUCT_ID = 'pricing-impact';

export const PRICING_TABLE_LAYOUT = {
  CHECKBOX_COLUMN_WIDTH: 32,
  CUSTOMERS_COLUMN_COUNT: 8,
  ESTIMATED_ROW_HEIGHT: 57,
  HEADER_HEIGHT: 42,
  ITEM_DETAIL_REGULAR_COLUMN_COUNT: 13,
  NAME_COLUMN_MIN_WIDTH: 180,
  NAME_COLUMN_PERCENTAGE: 20,
  REGULAR_COLUMN_COUNT: 10,
  SORT_ARROW_WIDTH: 12,
};

export const COLUMN_WIDTH = {
  M: { maxSize: 160, minSize: 112 },
  S: { maxSize: 112, minSize: 80 },
  XS: { maxSize: 80, minSize: 64 },
};
